<template>


<section class="overflow-hidden pt-2 pb-8 w-full bg-white lg:pb-16 lg:pt-4">
  <div class="px-4 mx-auto max-w-6xl xl:px-12 2xl:px-4">

    <h2 class="mb-6 text-2xl font-extrabold text-center font-ww-bold lg:text-left xl:text-42 md:text-3xl xl:!leading-tight">
      The Compounding Effect:<br>
      Your Brain on Month 8 vs. Month 1
    </h2>

    <div class="max-w-4xl text-base font-ww-regular xl:text-xl md:text-lg">
        This is not a magic potion.
        <br><br>
        It’s not supposed to "fix" you overnight.
        <br><br>

        The real power? It's in the <strong>compound effect.</strong>
        <br><br>

See, every single day you take your Mindflow, you're giving your body the building blocks it needs to support optimal brain function. Your cells get the nutrients they've been missing. Your brain gets the support it craves. Your body gets the balance it needs.
        <br><br>
One day? You might not notice much.
<br><br>
    </div>

 <div class="flex relative flex-col lg:flex-row">
    <div class="text-base lg:max-w-2xl font-ww-regular xl:text-xl md:text-lg xl:pr-0 lg:pr-10">
        But when you consistently fuel your body with ingredients like <strong>Alpha GPC</strong> (which supports acetylcholine production for focus), <strong>Lion's Mane</strong> (which helps support healthy nerve growth), and <strong>Cognitiq®</strong> (clinically studied to support BDNF levels—your brain's growth factor)...
        <br><br>
<strong>That's when things start to shift.</strong>
<br><br>
Because those daily servings start working together. The <strong>Electroprime™</strong> keeps you hydrated while the organic caffeine energizes. The <strong>Grass-Fed Collagen</strong> supports your gut-brain connection while the <strong>Chaga</strong> helps manage oxidative stress.
    </div>

    <div class="mx-auto lg:mx-0"> 
        <nuxt-img sizes="xs:269px sm:359px md:384px lg:1384px xl:384px 2xl:384px" src="/assets/images/right-img-upsell-new.png" alt="Mindflow" width="636" height="399" class="lg:absolute w-96 xl:w-[536px] right-[-4%] xl:right-[-20%] -bottom-4" />
    </div>

 </div>

 <div class="mt-4 text-base font-ww-regular xl:text-xl md:text-lg lg:mt-6">
   
    It's like an orchestra—each ingredient playing its part, day after day, building on yesterday's foundation.
30 days in? 90 days? That consistent support may help you feel sharper, more focused, and more energized than you have in years.*
<br><br>
It's not luck. It's not genetics.
<br><br>                
It's the compound effect of giving your brain what it needs—<strong>consistently</strong>.
<br><br>
And that's exactly what Mindflow is designed to support.
<br><br>
(Statements regarding dietary ingredients are based on preliminary research and are not intended to diagnose, treat, cure, or prevent any disease. Individual results vary.)
 </div>

   

  </div>
</section>



</template>